/**
 * 入口文件
 *
 * @author yusangeng@outlook.com
 */
import importer, { importModule, importScript, importStyle } from './importer';
export { importModule, importScript, importStyle };
export default importer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7R0FJRztBQUVILE9BQU8sUUFBUSxFQUFFLEVBQUUsWUFBWSxFQUFFLFlBQVksRUFBRSxXQUFXLEVBQUUsTUFBTSxZQUFZLENBQUE7QUFFOUUsT0FBTyxFQUFFLFlBQVksRUFBRSxZQUFZLEVBQUUsV0FBVyxFQUFFLENBQUE7QUFFbEQsZUFBZSxRQUFRLENBQUEifQ==